<template>
  <div>
    <div class="headerCate">
      <h1>Lista de Subcategorías</h1>

      <v-data-table 
      :headers="headers" 
      :items="subcategorias"
      :header-props="{ class: 'red-header' }"
      :search="searchTerm"
      >

        <!-- Sección superior de la tabla -->
        <template v-slot:top>
          <div style="margin-bottom: 50PX;">
            <!-- Barra de búsqueda y botón de agregar -->
            <div class="row justify-space-between mx-auto">
              <v-text-field
                label="Buscador"
                placeholder="Ingrese por favor una palabra"
                append-icon="mdi-magnify"
                dense
                outlined
                color="primary"
                class="col-md-5"
                @input="search"
              ></v-text-field>

              <div class="btn">
                <addSubcategoria 
                :category="category"
                />
              </div>
            </div>
          </div>
        </template>

        <template v-slot:[`item.nombreTipoProducto`]="{ item }">
          <span class="custom-font">{{ item.nombreTipoProducto }}</span>
        </template>

        <template v-slot:[`item.descripcion`]="{ item }">
          <span class="custom-font">{{ item.descripcion }}</span>
        </template>

        <template v-slot:[`item.nombreCategoria`]="{ item }">
          <span class="custom-font">{{ item.nombreCategoria }}</span>
        </template>

        <template v-slot:[`item.action`]="{ item }">
        <!-- Botón de acción para abrir el diálogo de detalles  -->
        <v-icon
          color="primary"
          size="x-large"
        ></v-icon>
        
        <div class="actions">

          <detailsSubcategory
            :status="item.activeDialogClient"
            :subcategoryProps="item"
            style="margin-left:1vh"
            @close="setActiveDialog({ status: false, index: item.index })"
          />
          <v-btn
            class="btnDetails"
            icon    
            x-large
            dark
            text
            @click = "deleteSubCategorie(item.idTipoProducto)"
            style="background-color: transparent; margin-left:1vh"
          >
            <v-icon color="primary">mdi-delete</v-icon>
          </v-btn>
        </div>
      </template>

      </v-data-table>

    </div>
  </div>
</template>
  
<script>

  import addSubcategoria from "@/views/categories_board/pages/add_subcategories/add_subcategories_page.vue";
  import detailsSubcategory from "@/views/categories_board/pages/detail_subcategories/detail_page.vue";
  import  EventBus  from '@/utils/event_bus.js';
  import Swal from "sweetalert2";

  import { mapActions, mapGetters } from "vuex";
  import {
    BOARD_M,
    GET_SUBCATEGORIES,
    ACTION_GET_SUBCATEGORIES,
    ACTION_DELETE_DELETE_SUBCATEGORIES
  } from "@/views/categories_board/store/types/types.js";

  export default {
    name: "listSubcategoriaComponent",
    components: {
      addSubcategoria,
      detailsSubcategory
    },
    props: {
      category: {
        required: true
      },
    },

    data() {
      return {
        searchTerm: "",
      };
    },

    mounted() {

      try {
        this.getActionsubcategories(this.category.idCategoriaComercial);
        this.$forceUpdate();
      } catch (error) {
        Swal.fire(
          'Error',
          'Hubo un problema al cargar las subcategorías.',
          'error'
        );
      } 

      EventBus.$on('reload-subcategories', async () => {
        await this.reloadSubcategories();
      });

      EventBus.$on('formSub-submitted-successfully', async () => {
        await this.reloadSubcategories();
      });

      EventBus.$on('update-subcategorie', async () => {
        await this.reloadSubcategories();
      });

      EventBus.$on('reload-delete-sub', async () => {
        await this.reloadSubcategories();
      });

      EventBus.$on('reload-create-submarketplace', async () => {
        await this.reloadSubcategories();
      });

      EventBus.$on('reload-update-categories-sub', async () => {
        await this.reloadSubcategories();
      });

    },

    methods: {
      
      ...mapActions({
        getActionsubcategories: `${BOARD_M}${ACTION_GET_SUBCATEGORIES}`,
        deleteActionSubCategories: `${BOARD_M}${ACTION_DELETE_DELETE_SUBCATEGORIES}`,
      }),

      async reloadSubcategories() {
        await this.getActionsubcategories(this.category.idCategoriaComercial);
      },

      search() {
        // Actualiza el término de búsqueda
        this.searchTerm = event.target.value;
      },

      async deleteSubCategorie(idTipoProducto) {
          const result = await Swal.fire({
            title: '¿Estás seguro?',
            text: 'Esta acción no se puede deshacer.',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#6E17A5',
          });

          if (result.isConfirmed) {
            
            this.deleteActionSubCategories(idTipoProducto);
            this.$forceUpdate();
            
          } else {
            Swal.fire({
              position: 'top-end',
              icon: 'info',
              title: 'La acción ha sido cancelada.',
              showConfirmButton: false,
              timer: 2500
            });
          }
      },

    },

    computed: {
      
      ...mapGetters({
        subcategorias: [`${BOARD_M}${GET_SUBCATEGORIES}`],
      }),

      headers() {
        return [
          {
            text: "Nombre",
            value: "nombreTipoProducto",
            align: "center",
            sortable: false,
            class: "primary--text text-h1 text-md-h5 text-lg-h5 font-weight-medium text-subtitle-1",
          },
          {
            text: "Descripción",
            value: "descripcion",
            align: "center",
            sortable: false,
            class: "primary--text text-h1 text-md-h5 text-lg-h5 font-weight-medium text-subtitle-1",
          },
          {
            text: "Categoría",
            value: "nombreCategoria",
            align: "center",
            sortable: false,
            class: "primary--text text-h1 text-md-h5 text-lg-h5 font-weight-medium text-subtitle-1",
          },
          {
            value: "action",
            sortable: false,
            align: "left",
            //class: "primary--text mdi-pencil text-subtitle-1 ",
          },
        ];
      },

    },
  };

</script>

<style scoped>

  .headerCate h1 {
    margin-bottom: 55px;
  }

  .actions v-icon {
    font-size: 24px;
  }

  .custom-font {
    font-size: 20px;
  }

  /* Define los estilos (Tipo de letra) para las etiquetas h1,h2,h3,h4,h5,h6   */
  body {
    font-family: 'Nunito Sans', sans-serif;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: 'Amsi Pro',  sans-serif;
    color: #2D0049;
    font-weight: normal;
  }
  
   /* Estilos para el botón de eliminar */
  .btnDetails .v-icon {
    color: #6E17A5;
    margin-bottom: 19px;
  }


  .actions{
    display:flex
  }

</style>




  
    

    
      

      




